import {
  CARDIO,
  COMBAT_SPORTS,
  FLEXIBILITY_AND_MOBILITY,
  FUNCTIONAL_FITNESS,
  GROUP_FITNESS,
  GymSubtype,
  HEALTH_CLUB,
  MIND_BODY,
  OTHER,
  OUTDOOR_ACTIVITIES,
  PERSONAL_TRAINING,
  SPECIALTY_TRAINING,
  SPORTS_SPECIFIC_TRAINING,
  STRENGTH,
} from "../constants/gymSubtypes";

export function getGymTypeFromSubtype(subtype: GymSubtype) {
  const subtypeMap: Record<string, readonly string[]> = {
    Strength: STRENGTH,
    "Functional Fitness": FUNCTIONAL_FITNESS,
    "Combat Sports": COMBAT_SPORTS,
    "Group Fitness": GROUP_FITNESS,
    "Flexibility and Mobility": FLEXIBILITY_AND_MOBILITY,
    "Mind Body": MIND_BODY,
    "Outdoor Activities": OUTDOOR_ACTIVITIES,
    "Sports Specific Training": SPORTS_SPECIFIC_TRAINING,
    "Specialty Training": SPECIALTY_TRAINING,
    Cardio: CARDIO,
    "Personal Training": PERSONAL_TRAINING,
    "Health Club": HEALTH_CLUB,
    Other: OTHER,
  };

  for (const [businessType, subtypes] of Object.entries(subtypeMap)) {
    if ((subtypes as readonly string[]).includes(subtype)) {
      return businessType;
    }
  }

  return "";
}
